import {AuthService} from "@/service/auth";

const state = {};

const getters = {};

const actions = {
    confirm_email(ctx, token) {
        return AuthService.getBareToken().then(res => AuthService.confirm_email(token, res.data.token));
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};